// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dmYGYqsZQSSCFcEsHqQ8 {
  display: inline-block;
  padding: 0.5em 0.2em;
  border-radius: 0.5em;
  color: var(--text-color);
  text-transform: uppercase;
  letter-spacing: 0.1em;
  margin-right: 0.5em;
  margin-bottom: 0.5em;
  font-size: 0.8em;
  font-weight: 600;
  font-family: var(--text-font);
}
`, "",{"version":3,"sources":["webpack://./src/styles/Label.module.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,oBAAoB;EACpB,wBAAwB;EACxB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;AAC/B","sourcesContent":[".label {\n  display: inline-block;\n  padding: 0.5em 0.2em;\n  border-radius: 0.5em;\n  color: var(--text-color);\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  margin-right: 0.5em;\n  margin-bottom: 0.5em;\n  font-size: 0.8em;\n  font-weight: 600;\n  font-family: var(--text-font);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"label": `dmYGYqsZQSSCFcEsHqQ8`
};
export default ___CSS_LOADER_EXPORT___;
